<mat-dialog-content class="dialog__content mj-secondary-card">
  <section class="dialog__header">
    <h2 class="otp-h2 header" i18n>Изтекла сесия</h2>
    <button
      matMiniFab
      type="button"
      class="otp-button"
      data-otp-color="white"
      aria-label="Затвори"
      i18n-aria-label
      mat-dialog-close
    >
      <mat-icon svgIcon="otp-close" />
    </button>
  </section>

  <section class="mj-main-card">
    <mat-icon svgIcon="otp-finishline-96x96" class="title-icon"></mat-icon>
    <p class="otp-p card-text" i18n>
      Сесията ти е изтекла. За да продължиш, трябва да влезеш отново в профила си.
    </p>
    <a
      matButton="filled"
      class="login-button"
      routerLink="/authentication/login"
      [queryParams]="{ redirectUrl: data.redirectUrl }"
      mat-dialog-close
      i18n
      >Вход</a
    >
  </section>
</mat-dialog-content>
